import React from 'react';
import Col from 'react-bootstrap/Col';
import Skeleton from 'react-loading-skeleton';
import ShoppingCartProgressBar from '../../../components/ecommerce/shopping-cart-progress/shopping-cart-progress.component';

function ReviewOrderHeaderComponent({ MainContent }) {
  return (
    <>
      
      <ShoppingCartProgressBar />
    </>
  );
}

export default ReviewOrderHeaderComponent;
